import { render, staticRenderFns } from "./CustomVisualCard.vue?vue&type=template&id=3fe38fa4&"
import script from "./CustomVisualCard.vue?vue&type=script&lang=js&"
export * from "./CustomVisualCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports